import { useTranslation } from "react-i18next";
import type { LunchScope } from "./lunchScope";

// Превключвателят „Всички / Без обедно / Само обедно" в „Асортименти" и
// „Категории". Показва се само когато в периода има продажби от обедно меню —
// иначе е шум за заведенията без обедно. Видът е сегментът от реда с датата.

const SCOPES: { value: LunchScope; labelKey: string }[] = [
  { value: "all", labelKey: "reportsPage.lunchScopeAll" },
  { value: "regular", labelKey: "reportsPage.lunchScopeRegular" },
  { value: "lunch", labelKey: "reportsPage.lunchScopeLunch" },
];

type Props = {
  value: LunchScope;
  onChange: (scope: LunchScope) => void;
};

export const LunchScopeToggle = ({ value, onChange }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      role="group"
      aria-label={t("reportsPage.lunchScopeLabel")}
      className="flex h-9 shrink-0 items-center gap-[3px] rounded-lg border border-shade-3 bg-surface p-[3px]"
    >
      {SCOPES.map((scope) => {
        const active = scope.value === value;
        return (
          <button
            key={scope.value}
            type="button"
            onClick={() => onChange(scope.value)}
            aria-pressed={active}
            className={`h-full rounded-md px-3 text-[12.5px] font-bold transition-colors ${
              active
                ? "bg-brand-tint text-brand-deep-ink"
                : "text-soft hover:bg-fill"
            }`}
          >
            {t(scope.labelKey)}
          </button>
        );
      })}
    </div>
  );
};
